import { createTheme } from "@mui/material/styles";
export const ui_colors = {
  primary: "#3567D6",
  secondary: "#3CD0FF",
  primaryBack: "#F5F2F0",
  secondaryBack: "#F7F6F6",
  semiPrimary: "#f5f9ff",
  textPrimary: "#7F7F7F",
  lightGray: "#D9D9D9",
  pending: "#F7B217",
  error: "#ff0000",
  // Smart Reporting New Page Colors
  primaryBlue: "#1D47A4",
  accentBlue: "#4674D9",
  darkNavy: "#022674",
  darkBlueSection: "#1C3D7A",
  darkOverlay: "#1C1B1D",
  grayText: "#4C4C4C",
  darkHeading: "#282D4D",
  lightGrayText: "#949499",
  lightBlue: "#E8F2FF",
  redAccent: "#C6605F",
  greenAccent: "#369868",
};

export const border = (width = 1) => `${width}px solid #${ui_colors.lightGray}`;

export const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: `'IBM Plex Sans', 'Poppins', Inter`,
    },
  },

  palette: {
    primary: {
      main: ui_colors.primary,
    },
    secondary: {
      main: ui_colors.secondary,
    },
    error: {
      main: ui_colors.error,
    },
  },

  components: {
    MuiSkeleton: {
      defaultProps: {
        animation: "pulse",
      },
    },

    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          scale: "1.1",
          padding: "8px",
          textTransform: "capitalize",
        },
      },
    },

    MuiToolbar: {
      styleOverrides: {
        root: {
          boxShadow: "none",
        },
      },
    },

    MuiTypography: {
      styleOverrides: {
        h1: {
          color: "#1D47A4",
          fontFamily: "Poppins",
          fontSize: "32px",
          fontWeight: "500",
          lineHeight: "40px",
          letterSpacing: 0,
        },
        h1Mobile: {
          color: "#1D47A4",
          fontFamily: "Poppins",
          fontSize: "16px",
          fontWeight: "600",
          display: "block",
          letterSpacing: 0,
        },
        h2: {
          color: "#4C4C4C",
          fontFamily: "Poppins",
          fontSize: "24px",
          fontWeight: "600",
          letterSpacing: 0,
        },
        h2Mobile: {
          color: "#4C4C4C",
          fontFamily: "Poppins",
          fontSize: "10px",
          fontWeight: "600",
          display: "block",
          letterSpacing: 0,
        },
        h3: {
          color: "#1D47A4",
          fontFamily: "Poppins",
          fontSize: "24px",
          fontWeight: "600",
          letterSpacing: 0,
        },
        h3Normal: {
          color: "#1D47A4",
          fontFamily: "Poppins",
          fontSize: "24px",
          fontWeight: "500",
          letterSpacing: 0,
        },
        h3Mobile: {
          color: "#1D47A4",
          fontFamily: "Poppins",
          fontSize: "10px",
          fontWeight: "600",
          display: "block",
          letterSpacing: 0,
        },
        h4: {
          color: "#4C4C4C",
          fontFamily: "Poppins",
          fontSize: "24px",
          fontWeight: "500",
          letterSpacing: 0,
        },
        h4Mobile: {
          color: "#4C4C4C",
          fontFamily: "Poppins",
          fontSize: "10px",
          fontWeight: "500",
          display: "block",
          letterSpacing: 0,
        },

        h5: {
          color: "#1D47A4",
          fontFamily: "Poppins",
          fontSize: "20px",
          fontWeight: "500",
          letterSpacing: 0,
        },
        h5Underline: {
          color: "#1D47A4",
          fontFamily: "Poppins",
          fontSize: "20px",
          fontWeight: "500",
          textDecoration: "underline",
          letterSpacing: 0,
        },
        h5Grey: {
          color: "#4C4C4C",
          fontFamily: "Poppins",
          fontSize: "20px",
          fontWeight: "500",
          letterSpacing: 0,
          display: "block",
        },
        h5Mobile: {
          color: "#1D47A4",
          fontFamily: "Poppins",
          fontSize: "8px",
          fontWeight: "500",
          display: "block",
          letterSpacing: 0,
        },
        h6: {
          color: "#4C4C4C",
          fontFamily: "Poppins",
          fontSize: "32px",
          fontWeight: "500",
          letterSpacing: 0,
        },
        h6Mobile: {
          color: "#4C4C4C",
          fontFamily: "Poppins",
          fontSize: "10px",
          fontWeight: "500",
          display: "block",
          letterSpacing: 0,
        },

        body1: {
          color: "#4C4C4C",
          fontFamily: "Poppins",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: "600",
          letterSpacing: 0,
        },
        body1Mobile: {
          color: "#4C4C4C",
          fontFamily: "Poppins",
          fontSize: "5px",
          fontStyle: "normal",
          fontWeight: "600",
          display: "block",
          letterSpacing: 0,
        },
        body2: {
          color: "#4C4C4C",
          fontFamily: "Poppins",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: "500",
          letterSpacing: 0,
        },
        body2Mobile: {
          color: "#4C4C4C",
          fontFamily: "Poppins",
          fontSize: "8px",
          fontStyle: "normal",
          fontWeight: "500",
          display: "block",
          letterSpacing: 0,
        },
        body3: {
          color: "#1D47A4",
          fontFamily: "Poppins",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: "500",
          letterSpacing: 0,
          display: "block",
        },
      },
    },

    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
    },

    MuiTabs: {
      styleOverrides: {
        root: {
          width: "100%",
          fontFamily: "Poppins",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: "500",
          lineHeight: "normal",
          justifyContent: "space-between",
        },
      },
    },

    MuiSelect: {
      defaultProps: {
        MenuProps: {
          sx: {
            background: "#000",
            ".MuiMenu-paper": {
              borderRadius: 8,
              border: border(),
            },
          },
        },
      },
      styleOverrides: {
        outlined: {
          "&.MuiOutlinedInput-input": {
            padding: "8px 12px",
          },
          "&.MuiPaper-root": {
            borderRadius: 8,
            border: border(),
            // background: "#b94040",
          },
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          color: "#FFF",
          textAlign: "center",
          fontFamily: "Poppins",
          fontSize: "20px",
          fontWeight: "600",
          display: "inline-flex",
          padding: "12px 20px",
          textDecoration: "none",
          borderRadius: "10px",
          transition: "all 200ms !important",
          boxShadow: "none",
          textTransform: "none",
          letterSpacing: 0,
          width: "fit-content",
          "&.Mui-disabled": {
            background: "transparent",
            boxShadow: `inset 0px 0px 0px 1px ${ui_colors.primary}`,
          },
        },

        outlined: {
          color: ui_colors.primary,
          borderColor: ui_colors.primary,
          ":hover": {
            boxShadow: "none",
          },
        },
        dark: {
          background: "#3567D6",
          boxShadow: "4px 4px 4px 0px rgba(0,0,0,0.25)",
          ":hover": {
            background: "#fff",
            border: "1px solid #3567D6",
            color: "#3567D6",
          },
        },
        mobile: {
          fontSize: "10px",
          fontWeight: "500",
          padding: "4px 8px",
          borderRadius: "8px",
          background: "#3567D6",
          boxShadow: "4px 4px 4px 0px rgba(0,0,0,0.25)",
          ":hover": {
            background: "#2c3649",
            color: "white",
          },
        },
        products: {
          color: "#1E1E1E",
          fontSize: "14px",
          padding: "4px 8px 4px 8px",
          ":hover": {
            boxShadow: "none",
            background: "transparent",
          },
        },
        outlined_red: {
          color: ui_colors.error,
          background: "#fff",
          boxShadow: "inset 0px 0px 0px 1px #ff0000",
          ":hover": {
            boxShadow: "inset 0px 0px 0px 1px #ff0000",
          },
        },
        text: {
          boxShadow: "none",
        },
      },
    },
  },
});
